import type { ProjectsFilterType } from './ProjectsFilter.tsx';

export type CountActiveFiltersInProjectsFilterOptions = {
    countDateFilters?: boolean;
};

export function countActiveFiltersInProjectsFilter(
    filter: ProjectsFilterType,
    options?: CountActiveFiltersInProjectsFilterOptions,
) {
    let filtersCount = 0;
    filter.metaResults.forEach(({ metaValues }) => {
        filtersCount += metaValues.length;
    });
    filtersCount += filter.projects.length;
    filtersCount += filter.projectCategories.length;
    // isFinite(null) === true; Also, isNaN(null) === false.
    filtersCount += Number.isFinite(filter.projectBudget.from ?? undefined)
        ? 1
        : 0;
    filtersCount += Number.isFinite(filter.projectBudget.to ?? undefined)
        ? 1
        : 0;

    if (options?.countDateFilters) {
        filtersCount += filter.fromDate ? 1 : 0;
        filtersCount += filter.toDate ? 1 : 0;
    }
    return filtersCount;
}
